export default __webpack_public_path__ + "static/media/logo1.1fe93a37.png";